export default {
  CATEGORIES_LIST: "Liste des catégories",
  ADD_CATEGORY: "Ajouter une catégorie",
  CATEGORY_ADDED: "Catégorie ajoutée",
  EDIT_CATEGORY: "Modifier une catégorie",
  CATEGORY_UPDATED: "Catégorie mise à jour",
  SUB_CATEGORY: "Sous-catégorie",
  DELETE_THIS_CATEGORY: "Supprimer cette catégorie ?",
  CATEGORY_DELETED: "Catégorie supprimée",
  ACTIVATE: "Activer",
  DEACTIVATE: "Désactiver",
  CATEGORY_ACTIVATED: "Catégorie activée",
  CATEGORY_DEACTIVATED: "Catégorie désactivée",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  COLOR: "Couleur",
  ICON: "Icône",
  PARENT_CATEGORY: "Catégorie parente",
  IN_SUB_CATEGORY: "Sous-catégorie",
  HIERARCHICAL_CATEGORY: "Hiérarchique",
  REPORTING_NAME_EDIBLE: "Comestible",
  REPORTING_NAME_NON_EDIBLE: "Non comestible",
};
